import { render, staticRenderFns } from "./ServiceDurationTable.vue?vue&type=template&id=711185f2&scoped=true"
import script from "./ServiceDurationTable.vue?vue&type=script&lang=js"
export * from "./ServiceDurationTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceDurationTable.vue?vue&type=style&index=0&id=711185f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711185f2",
  null
  
)

export default component.exports